module.exports = __webpack_public_path__ + "img/suoxie_grey.6e7d1fca.svg";